import { Fragment, useRef } from 'react';
import css from './App.module.scss';
import Header from './components/header/Header';

function App() {

  const ref = useRef();
  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();

  return (
    <Fragment>
      <Header innerRef={ref} />
      <section className={css.lead} ref={ref}>
        <p>Ну что, мужчины? Уже поджидаете свой самый главный мужественный праздник? Да, да, 23 февраля приближается просто стремительно!</p>
        <p>А вы, женщины, ещё не придумали, чем порадовать своих любимых? В помощь вам редакция «ВБ!» подготовила рейтинг подарков для мужчин на любой вкус и кошелёк от разных магазинов нашего города.</p>
        <p>Смотрите, читайте, изучайте, покупайте! И дарите с любовью!</p>
      </section>
      <section className={css.buttons}>
        <div className={css.button} onClick={ () => ref1?.current?.scrollIntoView({ behavior: "smooth" }) }>Для самых стильных, деловых и хозяйственных</div>
        <div className={css.button} onClick={ () => ref2?.current?.scrollIntoView({ behavior: "smooth" }) }>Для самых модных и элегантных</div>
        <div className={css.button} onClick={ () => ref3?.current?.scrollIntoView({ behavior: "smooth" }) }>Для самых мужественных и увлеченных</div>
      </section>
      <section className={css.container}>
        <h2 className={css.sectionHead} ref={ref1}>Для самых стильных, деловых и хозяйственных</h2>
        <div className={css.card}>
          <div className={css.cardInner}>
            <div className={css.cardImages}>
              <img style={{ maxWidth: "100%"}} src="./images/raduga_sert_small.jpg" />
            </div>
            <div className={css.cardTexts}>
              <h4>Рейтинг подарков от магазинов «Радуга» и «Профи»:</h4>
              <ul>
                <li>Парфюмерные наборы</li>
                <li>Пена, гели до и после бритья</li>
                <li>Органайзеры</li>
                <li>Часы наручные</li>
                <li>Галантерея</li>
                <li>Наборы инструментов</li>
                <li>Ящики для инструментов</li>
                <li>Подарочные сертификаты.</li>
              </ul>
              <div>
                <strong>
                  Всегда рады видеть вас в наших магазинах:
                  <ul>
                    <li>«Радуга» (ул. Молодежи, 4)</li>
                    <li>«Профи» (ул. Ленина, 21)</li>
                  </ul>
              Сайт: <a href="https://shopraduga.ru/" target="_blank">shopraduga.ru</a></strong>
              </div>
              <div className={css.label}>Реклама. ИП Ольков Георгий Юрьевич. ИНН 660200017888. ERID 2Vtzqwm2VPE</div>
            </div>
          </div>
        </div>
        <h2 className={css.sectionHead} ref={ref2}>Для самых модных и элегантных</h2>
        <div className={css.card}>
          <div className={css.cardInner}>
            <div className={css.cardImages}>
              <img style={{ maxWidth: "100%"}} src="./images/happy_loving_small.jpg" />
            </div>
            <div className={css.cardTexts}>
              <h4>Рейтинг подарков от магазина «Всё для мужчин»</h4>
              <ul>
                <li>Футболки поло</li>
                <li>Ремни</li>
                <li>Подтяжки</li>
                <li>Джинсы</li>
                <li>Джемперы</li>
                <li>Рубашки</li>
                <li>Спортивные костюмы</li>
                <li>Шорты</li>
                <li>Боксеры</li>
                <li>Носки</li>
                <li>Куртки</li>
              </ul>
              <div>
                <strong>Ждём вас по адресу: ул. Мира, 4</strong>
              </div>
              <div className={css.label}>Реклама. ИП Ахундов Нураддин Наби Оглы. ИНН 660200045564. ERID 2VtzquqvTUL</div>
            </div>
          </div>
        </div>
        <h2 className={css.sectionHead} ref={ref3}>Для самых мужественных и увлечённых</h2>
        <div className={css.card}>
          <div className={css.cardInner}>
            <div className={css.cardImages}>
              <img style={{ maxWidth: "100%"}} src="./images/fisherwoman_small.jpg" />
            </div>
            <div className={css.cardTexts}>
              <h4>Рейтинг подарков от рыбацкой лавки «У Петровича»</h4>
              <ul>
                <li>Распродажа зимних костюмов (скидка — 1000 руб.)</li>
                <li>Зимние рыбацкие сапоги (большой выбор)</li>
                <li>Термосы фирмы «Биосталь» (в ассортименте)</li>
                <li>Мормышки, балансиры, блесны</li>
                <li>Подарочные сертификаты</li>
                <li>И многое другое.</li>
              </ul>
              <div>
                <strong>Приходите! Ул. Мира, 13 «а»</strong>
              </div>
              <div className={css.label}>Реклама. ИП Попов Михаил Петрович. ИНН 660200005900. ERID 2VtzqupbYC8</div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
}

export default App;
